import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useDeleteTeamInvitation from "@babackapp/private-api-client/client/use-delete-team-invitation";
import useTranslation from "@babackapp/translations/use-translation";
import { Avatar, AvatarFallback } from "@babackapp/ui/components/avatar";
import { Button } from "@babackapp/ui/components/button";
import { MailIcon } from "lucide-react";
import { format } from "date-fns";

type TeamInvitationListItemProps = {
  email: string;
  invitedAt: number;
};

export function TeamInvitationListItem({
  email,
  invitedAt,
}: TeamInvitationListItemProps) {
  const { data: shop } = useCurrentShopSuspense();

  const { mutateAsync: removeInvitation } = useDeleteTeamInvitation(
    shop.id,
    email,
  );
  const t = useTranslation();

  return (
    <div className="flex items-center gap-4 p-2">
      <Avatar className="border border-border">
        <AvatarFallback>
          <MailIcon className="size-6 text-muted-foreground" />
        </AvatarFallback>
      </Avatar>
      <div className="flex flex-col gap-1 flex-1">
        <span className="font-medium">{email}</span>
        <span className="text-muted-foreground text-sm">
          {format(invitedAt, "dd/MM/yyyy")}
        </span>
      </div>
      <Button
        size="sm"
        variant="link"
        className="text-destructive hover:underline"
        onClick={() => removeInvitation()}
      >
        {t("settings.team.delete")}
      </Button>
    </div>
  );
}
